import DemosSearchInput from '../../components/DemosSearchInput/DemosSearchInput'
import TagComponent from '../../components/TagComponent/TagComponent'
import {
  ContentType,
  contentSortParams,
  createSearchPageRoute,
} from 'shared-utilities'
import MarkdownText from '../MarkdownText/MarkdownText'
import { useMemo } from 'react'

export interface IDemoSearchAndTagProps {
  description?: string | JSX.Element
  demoCategories: string[]
}

const DemoSearchAndTags = ({
  description,
  demoCategories,
}: IDemoSearchAndTagProps) => {
  /* Reorder categories to move "Getting Started" to the beginning */
  const reorderedCategories = useMemo(() => {
    const categoriesCopy = [...demoCategories]
    const gettingStartedIndex = categoriesCopy.indexOf('Getting Started')
    if (gettingStartedIndex === -1) {
      return categoriesCopy
    }
    const [gettingStarted] = categoriesCopy.splice(gettingStartedIndex, 1)
    categoriesCopy.unshift(gettingStarted)
    return categoriesCopy
  }, [demoCategories])

  return (
    <section className="DemoSearchAndTags">
      <DemosSearchInput />
      <div className="DemoSearchAndTags__container">
        {description && typeof description === 'string' ? (
          <MarkdownText
            className="DemoSearchAndTags__description"
            text={description}
          />
        ) : (
          description
        )}
        {demoCategories && (
          <div className="Tags__wrapper flex flex-wrap">
            <TagComponent text="All Demos" link="/search" />
            {reorderedCategories.map((category) => (
              <TagComponent
                key={`demo-category-${category}`}
                text={category}
                link={createSearchPageRoute({
                  category: category,
                  contentType: ContentType.DEMO,
                  sort: contentSortParams.PUBLICATION_DATE_DESC,
                })}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  )
}

export default DemoSearchAndTags
